import { motion } from 'framer-motion';

import Dashboard from '@/features/GameWindow/Dashboard';

import { useStore } from '@/store/useStore';
import { useEffect } from 'react';
import { useAccountUm } from '@/unified-modules/account/useAccountUm';
import { getBalanceData } from '@/unified-modules/wallet/helpers/get-balance-data';
import { setGameWindowContext } from '@/store/actions.ts';

export const GameWindow = () => {
  const gameWindowOpen = useStore((s) => s.gameWindowContext.gameWindowOpen);
  const { keepSessionAlive } = useAccountUm();

  useEffect(() => {
    if (!gameWindowOpen) return;

    void keepSessionAlive();

    let isMounted = true;

    getBalanceData((balance: number | null) => {
      if (isMounted) {
        setGameWindowContext({ balance });
      }
    }).then();

    return () => {
      isMounted = false;
    };
  }, [gameWindowOpen, keepSessionAlive]);

  return (
    <>
      {gameWindowOpen && (
        <motion.div
          className="slot gw"
          key="menu"
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 20, opacity: 0 }}
          transition={{ duration: 0.3 }}
        >
          <Dashboard />
        </motion.div>
      )}
    </>
  );
};

export default GameWindow;
